module.exports = "/dist/de70266798097f4ad42807a2918ad97d.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-200italic.eot
// module id = 9
// module chunks = 0